import React from 'react';
import { withRouter } from 'react-router';
import { Switch, Route } from 'react-router-dom';

import { Consumer, find, map } from './utils';

let DefaultRender = props => React.createElement(Route, props);

class RouteView extends React.PureComponent {
  static setRender = render => (DefaultRender = render);

  render() {
    const {
      match: { path }
    } = this.props;

    return (
      <Consumer>
        {({ routes, matched, routePrefix }) => {
          const currentRoute = find(matched, v => path === v.match.path);

          let renderRoutes = [];
          if (currentRoute) {
            renderRoutes = currentRoute.route.children || [];
          }

          return (
            <Switch>
              {map(renderRoutes, ({ children, ...props }, i) => (
                <DefaultRender {...props} key={props.path || i} />
              ))}
            </Switch>
          );
        }}
      </Consumer>
    );
  }
}

export default withRouter(RouteView);
export const getRender = () => DefaultRender;
